export abstract class BaseButtonService {
  protected handledButtons: Set<HTMLElement>;
  protected eventListeners: Map<HTMLElement, (event: Event) => void>;

  constructor() {
    this.handledButtons = new Set<HTMLElement>();
    this.eventListeners = new Map<HTMLElement, (event: Event) => void>();
  }

  /**
   * Initialize logic for buttons manager.
   * Must be implemented by the subclass.
   */
  abstract initialize(): void;

  /**
   * Store event listener for cleanup
   */
  protected storeEventListener(
    element: HTMLElement,
    handler: (event: Event) => void
  ): void {
    this.eventListeners.set(element, handler);
  }

  /**
   * Cleanup method - removes all event listeners and clears state
   */
  destroy(): void {
    // Remove all event listeners
    this.eventListeners.forEach((handler, element) => {
      element.removeEventListener("click", handler);
      element.removeAttribute("data-unibo-handler-attached");
    });

    this.eventListeners.clear();
    this.handledButtons.clear();
  }
}
